// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
import { rgba } from 'polished';
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';

const S = {
  Container: styled.div`
    min-width: 181px;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
  `,
  List: styled.ul`
    display: flex;
    flex-direction: column;
    padding: 4px 0;
  `,
  Item: styled.li`
    padding: 9px 7px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #666666;
    cursor: pointer;

    &:hover {
      background-color: ${rgba('#000000', 0.15)};
    }
  `,
}

export { S as default };
